import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { select, Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { AppStateService } from './shared/app-state.service';
import { MasterDataService } from './shared/master-data.service';
import * as fromSettings from './shared/state/setting.reducer';
import * as settingsAction from './shared/state/settings.actions';
import * as fromApp from './state/app.state';
import { AppState } from './state/app.state';
import { SpinnerService } from './ui/spinner.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [MessageService]
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  msgs: any[];
  title = 'BTV-SyBi';
  loading = false;
  componentActive = true;
  errorMessage$: Observable<string>;

  watermark = environment.watermark.toString();

  faSpinner = faSpinner;

  constructor(private router: Router, private spinnerService: SpinnerService,
    private appState: AppStateService,
    private store: Store<AppState>, private messageService: MessageService,
    private masterDataService: MasterDataService) {
    this.router.events.subscribe((routerEvent: Event) => {
      this.checkRouterEvent(routerEvent);
    });
  }

  async ngOnInit() {
    this.spinnerService.connect().subscribe((state) => this.loading = state);
    this.errorMessage$ = this.store.pipe(select(fromSettings.getError));

    await this.masterDataService.getCounties();
    await this.masterDataService.getLocations();

    // Load settings once a user is looged in, it doesn't make sense earlier.
    this.store.pipe(select(fromApp.getCurrentUser)).subscribe(user => {
      if (user.id > 0) {
        setTimeout(() => {
          this.store.dispatch(new settingsAction.Load());
        }, 250);
      }
    });

    this.store.pipe(select(fromSettings.getSettings),
      takeWhile(() => this.componentActive)).
      subscribe((settings) => {
        console.info('Settings loaded, length: ', settings.length);
        this.appState.appReady$.next(settings.length > 0);
      });

    this.errorMessage$.subscribe(
      err => {
        if (err !== '') {
          this.messageService.add({ severity: 'error', summary: 'Einstellungen konten nicht geladen werden!', detail: err });
        }
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      Array.from(document.querySelectorAll('.watermarked')).forEach(function (el: Element) {
        if (el instanceof HTMLElement) {
          el.dataset.watermark = (' ' + el.dataset.watermark + ' ').repeat(555);
        }
      });
    }, 50);
  }

  ngOnDestroy() {
    this.componentActive = false;
  }

  checkRouterEvent(routerEvent: Event): void {
    if (routerEvent instanceof NavigationStart) {
      this.loading = true;
    }

    if (routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError) {
      this.loading = false;
    }
  }
}
